export const TEXTAREA_COUNTER_LIVE_THRESHOLD = 20;

export const formatTextareaCharacterCount = (count: number, maxLength?: number): string =>
  `${count}${maxLength ? `/${maxLength}` : ""}`;

export const shouldAnnounceTextareaCharacterCount = (
  count: number,
  maxLength?: number,
): boolean => {
  if (!maxLength) {
    return false;
  }

  return count >= maxLength - TEXTAREA_COUNTER_LIVE_THRESHOLD;
};
